import { Component, Vue } from 'types-vue'
import { LOPDPages } from '../../router'

@Component
export default class Create extends Vue {
  onClickCreateButton() {
    this.$router.push({ name: LOPDPages.Main })
  }
}
